import { useCallback, useMemo, useState } from "react";
import type {
	IssueSummaryPopoverProps,
	IssueSummaryPopoverViewModel,
	IssueListItem,
} from "./IssueSummaryPopover.types";
import { buildAllIssueList } from "./IssueSummaryPopover.helpers";

// ============================================================================
// ViewModel Hook
// ============================================================================

export function useIssueSummaryPopoverViewModel(props: IssueSummaryPopoverProps): IssueSummaryPopoverViewModel {
	const { issues, skippedIssueIds, currentStep, onNavigateToIssue } = props;

	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const isOpen = Boolean(anchorEl);

	const items = useMemo(() => {
		const allItems = buildAllIssueList(issues, skippedIssueIds);
		return allItems.filter((item) => item.step === currentStep);
	}, [issues, skippedIssueIds, currentStep]);

	const issueCount = items.length;

	const handleOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	}, []);

	const handleClose = useCallback(() => {
		setAnchorEl(null);
	}, []);

	const handleIssueClick = useCallback(
		(item: IssueListItem) => {
			onNavigateToIssue(item.step, item.issueIndex);
			setAnchorEl(null);
		},
		[onNavigateToIssue],
	);

	return {
		anchorEl,
		isOpen,
		issueCount,
		items,
		handleOpen,
		handleClose,
		handleIssueClick,
	};
}
